import { Component, Input } from '@angular/core';

// One short muted message for a list, grid or panel with nothing to show
@Component({
  selector   : 'wor-empty-state',
  styles: [require('./empty-state.component.scss')],
  template: require('./empty-state.component.html')
})
export class EmptyStateComponent {
  @Input() message : string;
}
